import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Form, Input, Label } from "../../../styles";
import { useUserContext } from "../../../context/user_context";
import { useDebtContext } from "../../../context/debt_context";
import Api from "../../../api/axios";
import { amountPlaceholder, emailPlaceholder, namePlaceholder, phonePlaceholder } from "../../../utils/data";
import { formatDate } from "../../../utils/helpers";


const EditDebtor = (props) => {

  const [issending, setissending] = useState(false);

  const [formField, setformField] = useState({
    name: '', phone: '', mail: '', amount: '', real_due_date: '',
  });

  const {
    showEditDebtor, CloseEditDebtor,
    getDebtorData
  } = useDebtContext();

  const { btoken, stoken } = useUserContext();

  const { id: did, name, phone, mail, amount, real_due_date } = props;

  useEffect(() => {
    if (props) {
      setformField({
        name, mail, phone, amount, duedate: formatDate(new Date(real_due_date))
      });
    }
  }, [props]);


  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }

  function submitFn(e) {
    e.preventDefault();
    if (formField.name) {
      setissending(true);
      const data = {
        btoken, stoken, did,
        name: formField.name,
        mail: formField.mail,
        type: 'debtor',
        phone: formField.phone,
        amount: formField.amount,
        duedate: formField.duedate,
      };

      Api.post(`/editDebt`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            getDebtorData();
            CloseEditDebtor();
          }
        })
        .catch((error) => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.error("Name is required !!!");
    }
  }


  return (
    <>
      <Modal
        show={showEditDebtor}
        onHide={CloseEditDebtor}
        backdrop="static"
        keyboard={true}
        centered
        size="lg"
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <h6 className="fw-bold pry-text">
              Edit Debtor
            </h6>
          </Modal.Header>


          <div className="container">
            <Form onSubmit={(e) => submitFn(e)}>

              <Label> Name: <span>*</span> </Label>
              <Input
                type="text"
                name="name"
                placeholder={namePlaceholder}
                onChange={handleChange}
                required
                value={formField.name}
              />

              <Label> Email: <span>*</span>  </Label>
              <Input
                type="email"
                name="mail"
                placeholder={emailPlaceholder}
                onChange={handleChange}
                required
                value={formField.mail}
              />

              <Label> Phone Number: <span>*</span>  </Label>
              <Input
                type="number"
                name="phone"
                placeholder={phonePlaceholder}
                onChange={handleChange}
                required
                value={formField.phone}
              />

              <Label> Amount: <span>*</span>  </Label>
              <Input
                type="number"
                name="amount"
                placeholder={amountPlaceholder}
                onChange={handleChange}
                required
                value={formField.amount}
              />

              <Label> Due Date: <span>*</span>  </Label>
              <Input
                type="date"
                name="duedate"
                onChange={handleChange}
                required
                value={formField.duedate}
              />

              <div className="col-md-10 mb-4 mx-auto text-center">
                <Button
                  pry
                  type="submit"
                  disabled={issending}
                  className="btn m-0 w-100"  >
                  {issending ? 'loading...' : "Submit"}
                </Button>
              </div>
            </Form>
          </div>

        </Modal.Body>
      </Modal>

    </>
  );
};

export default EditDebtor;
